.discord-action-row {
	display: flex;
	flex-wrap: nowrap;
}
